<template>
    <div :class="{page: true, show: active}" :id="id">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'page',
    props: {
        id: {type: String, required: true},
        active: {type: Boolean, default: false}
    }
}
</script>

<style lang="scss" scoped>
    .page {
        display: none;
        flex-grow: 1; 
        padding-top: 40px; 
        margin-top: 200px; 
        margin-bottom: -200px;
        transition: margin-top .3s;
    }
    .page.show {display: block; margin-top: 0px; margin-bottom: 0px}
</style>